import { Menu, Button } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/s-logo.png";
import { useContext } from "react";
import { AuthContext } from "../../context/Auth";

function Sidenav({ color }) {
  const { user } = useContext(AuthContext);

  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  function firstTwoCaps(str) {
    return str.slice(0, 2).toUpperCase();
  }

  return (
    <>
      <div className="brand">
        <img src={logo} className="inline-block me-3" alt="log" />
        <span className="">Sawari Pakistan</span>
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        {(user?.role == 1 || user?.userRole?.permissions["Dashboard"]) && <Menu.Item key="17">
          <NavLink to="/overview">
            <span
              className="icon"
              style={{
                background: page === "overview" ? color : "",
              }}
            >
              {firstTwoCaps("Overview")}
            </span>
            <span className="label">Overview</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Airport Bookings"]) && <Menu.Item key="2">
          <NavLink to="/airport-bookings">
            <span
              className="icon"
              style={{
                background: page === "airport-bookings" ? color : "",
              }}
            >
              {firstTwoCaps("AT")}
            </span>
            <span className="label">Airport Bookings</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Rental Bookings"]) && <Menu.Item key="11">
          <NavLink to="/rental-bookings">
            <span
              className="icon"
              style={{
                background: page === "rental-bookings" ? color : "",
              }}
            >
              {firstTwoCaps("VR")}
            </span>
            <span className="label">Rental Bookings</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Tour bookings"]) && <Menu.Item key="12">
          <NavLink to="/tour-bookings">
            <span
              className="icon"
              style={{
                background: page === "tour-bookings" ? color : "",
              }}
            >
              {firstTwoCaps("TP")}
            </span>
            <span className="label">Tour Bookings</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Vehicles"]) && <Menu.Item key="3">
          <NavLink to="/vehicles">
            <span
              className="icon"
              style={{
                background: page === "vehicles" ? color : "",
              }}
            >
              {firstTwoCaps("Vehicles")}
            </span>
            <span className="label">Vehicles</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Category / Pricing"]) && <Menu.Item key="4">
          <NavLink to="/vehicles-type">
            <span
              className="icon"
              style={{
                background: page === "vehicles-type" ? color : "",
              }}
            >
              {firstTwoCaps("Category Pricing")}
            </span>
            <span className="label">Category / Pricing</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Airports"]) && <Menu.Item key="5">
          <NavLink to="/airports">
            <span
              className="icon"
              style={{
                background: page === "airports" ? color : "",
              }}
            >
              {firstTwoCaps("Airports")}
            </span>
            <span className="label">Airports</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Users"]) && <Menu.Item key="6">
          <NavLink to="/users">
            <span
              className="icon"
              style={{
                background: page === "users" ? color : "",
              }}
            >
              {firstTwoCaps("Users")}
            </span>
            <span className="label">Users</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Drivers"]) && <Menu.Item key="7">
          <NavLink to="/drivers">
            <span
              className="icon"
              style={{
                background: page === "drivers" ? color : "",
              }}
            >
              {firstTwoCaps("Drivers")}
            </span>
            <span className="label">Drivers</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Appointments"]) && <Menu.Item key="8">
          <NavLink to="/appointments">
            <span
              className="icon"
              style={{
                background: page === "appointments" ? color : "",
              }}
            >
              {firstTwoCaps("Appointments")}
            </span>
            <span className="label">Appointments</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Tour Packages"]) && <Menu.Item key="9">
          <NavLink to="/tours">
            <span
              className="icon"
              style={{
                background: page === "tours" ? color : "",
              }}
            >
              {firstTwoCaps("Tour Packages")}
            </span>
            <span className="label">Tour Packages</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Customers"]) && <Menu.Item key="10">
          <NavLink to="/customers">
            <span
              className="icon"
              style={{
                background: page === "customers" ? color : "",
              }}
            >
              {firstTwoCaps("Customers")}
            </span>
            <span className="label">Customers</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Add Ons"]) && <Menu.Item key="10">
          <NavLink to="/addons">
            <span
              className="icon"
              style={{
                background: page === "addons" ? color : "",
              }}
            >
              {firstTwoCaps("Add Ons")}
            </span>
            <span className="label">Add Ons</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Accounts"]) && <Menu.Item key="13">
          <NavLink to="/accounts">
            <span
              className="icon"
              style={{
                background: page === "accounts" ? color : "",
              }}
            >
              {firstTwoCaps("Accounts")}
            </span>
            <span className="label">Accounts</span>
          </NavLink>
        </Menu.Item>}
        {user?.role == 1 && <Menu.Item key="14">
          <NavLink to="/roles">
            <span
              className="icon"
              style={{
                background: page === "roles" ? color : "",
              }}
            >
              {firstTwoCaps("Roles")}
            </span>
            <span className="label">Roles</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Discount Codes"]) && <Menu.Item key="15">
          <NavLink to="/discount-codes">
            <span
              className="icon"
              style={{
                background: page === "discount-codes" ? color : "",
              }}
            >
              {firstTwoCaps("Discount Codes")}
            </span>
            <span className="label">Discount Codes</span>
          </NavLink>
        </Menu.Item>}
        {(user?.role == 1 || user?.userRole?.permissions["Settings"]) && <Menu.Item key="16">
          <NavLink to="/settings">
            <span
              className="icon"
              style={{
                background: page === "settings" ? color : "",
              }}
            >
              {firstTwoCaps("Settings")}
            </span>
            <span className="label">Settings</span>
          </NavLink>
        </Menu.Item>}
      </Menu>
    </>
  );
}

export default Sidenav;
